import { HttpClient, ListParams } from './http-client';
import Paginate from '../interfaces/paginate';
import Deal from '../interfaces/deal';
import AdditionalAmountParameterProducts from '../interfaces/deal';
import DealType from '../interfaces/deal-type';
import ClassifierValue from '../interfaces/classifierValue';
import { Product } from '../interfaces/product';
import Partner from '../interfaces/partner';
import RecycleDeal from '../interfaces/recycle-deal';

export class DealService extends HttpClient {
  index(farmId: string, params: ListParams) {
    return this.get<Paginate<Deal>>(`/api/farms/${farmId}/deals`, params);
  }

  show(farmId: string, id: string) {
    return this.get<Deal | RecycleDeal>(`/api/farms/${farmId}/deals/${id}`);
  }

  store(farmId: string, deal: Deal | RecycleDeal) {
    return this.post<Deal | RecycleDeal>(`/api/farms/${farmId}/deals`, deal);
  }

  update(farmId: string, id: string, deal: Deal | RecycleDeal) {
    return this.put<Deal | RecycleDeal>(
      `/api/farms/${farmId}/deals/${id}`,
      deal
    );
  }

  destroy(farmId: string, id: string) {
    return this.delete<Deal | RecycleDeal>(`/api/farms/${farmId}/deals/${id}`);
  }

  exportXls(farmId: string, params: ListParams) {
    return this.export(`/api/farms/${farmId}/deals`, params);
  }

  classifierValues(farmId: string, params: ListParams) {
    return this.get<Paginate<ClassifierValue>>(
      `/api/farms/${farmId}/deals/classifier-values`,
      params
    );
  }

  usedDealTypes(farmId: string, params?: ListParams) {
    return this.get<DealType[]>(
      `/api/farms/${farmId}/deals/used-deal-types`,
      params
    );
  }

  usedProductCategories(farmId: string, params?: ListParams) {
    return this.get<ClassifierValue[]>(
      `/api/farms/${farmId}/deals/used-product-categories`,
      params
    );
  }

  usedProductTypes(farmId: string, params?: ListParams) {
    return this.get<ClassifierValue[]>(
      `/api/farms/${farmId}/deals/used-product-types`,
      params
    );
  }

  usedProducts(farmId: string, params?: ListParams) {
    return this.get<Product[]>(
      `/api/farms/${farmId}/deals/used-products`,
      params
    );
  }

  usedPartners(farmId: string, params?: ListParams) {
    return this.get<Partner[]>(
      `/api/farms/${farmId}/deals/used-partners`,
      params
    );
  }

  usedDocumentNumbers(farmId: string, params?: ListParams) {
    return this.get<Deal[]>(
      `/api/farms/${farmId}/deals/used-document-numbers`,
      params
    );
  }

  usedProductWarehouses(farmId: string) {
    return this.get<Partner[]>(
      `/api/farms/${farmId}/deals/used-product-warehouses`
    );
  }

  docmentCount(farmId: string) {
    return this.get<number>(`/api/farms/${farmId}/deals/count`);
  }

  additionalAmountParameterProducts(farmId) {
    return this.get<AdditionalAmountParameterProducts[]>(
      `/api/farms/${farmId}/deals/medications-and-ppp`
    );
  }

  invoiceExportXls(farmId: string, id: string) {
    return this.export(`/api/farms/${farmId}/deals/${id}`);
  }

  generatePartyNumber(farmId: string, dealType: string, $params = {}) {
    return this.get<{ party_number: string }>(
      `/api/farms/${farmId}/deals/${dealType}/party-number`,
      $params
    );
  }

  partyNumbers(farmId: string, params: ListParams) {
    return this.get<any>(`/api/farms/${farmId}/deals/party-numbers`, params);
  }

  movedDealInvoiceExportXls(farmId: string, id: string) {
    return this.export(`/api/farms/${farmId}/deals/${id}/invoice/moved`);
  }
}
